import { Effect } from "../../Materials/effect";
var name = 'pbrBlockImageProcessing';
var shader = "#ifdef IMAGEPROCESSINGPOSTPROCESS\n\n\nfinalColor.rgb=clamp(finalColor.rgb,0.,30.0);\n#else\n\nfinalColor=applyImageProcessing(finalColor);\n#endif\nfinalColor.a*=visibility;\n#ifdef PREMULTIPLYALPHA\n\nfinalColor.rgb*=finalColor.a;\n#endif\n";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var pbrBlockImageProcessing = { name: name, shader: shader };
//# sourceMappingURL=pbrBlockImageProcessing.js.map